wbApp.controller('AmortizationScheduleCtrl', ['$scope', 'coursePriceSvc', 'invoiceSvc',
    function ($scope, coursePriceSvc, invoiceSvc) {

        if (!!$scope.invoiceID) {
            $scope.model.invoice = invoiceSvc.getByID($scope.invoiceID);
            $scope.model.invoice.$promise.then(function (data) {
                $scope.amortizationSchedules = data.amortizationSchedules;
            });
        }
        else {
            $scope.amortizationSchedules = coursePriceSvc.calculateAmortizationSchedules(
                $scope.model.invoice.total,
                moment().toDate(),
                $scope.amortizationScheduleTemplates);
        }
}]);